import React from 'react';
import { useNavigate } from 'react-router-dom';

const Classroom = () => {
  const navigate = useNavigate();

  const handleReturnToDashboard = () => {
    navigate('/educator/dashboard'); // Navigates back to the Educator Dashboard
  };

  return (
    <div style={styles.classroomContainer}>
      {/* Header */}
      <h1 style={styles.header}>Classroom</h1>
      <p style={styles.description}>
        This is a placeholder for the Classroom page. Content will be added here later.
      </p>

      {/* Return to Dashboard Button */}
      <button style={styles.returnButton} onClick={handleReturnToDashboard}>
        Return to Dashboard
      </button>
    </div>
  );
};

const styles = {
  classroomContainer: {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#f4f8fc',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
  },
  header: {
    fontSize: '28px',
    color: '#333',
    marginBottom: '10px',
  },
  description: {
    fontSize: '18px',
    color: '#666',
    marginBottom: '30px',
  },
  returnButton: {
    backgroundColor: '#007bff',
    color: '#fff',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    cursor: 'pointer',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
    transition: 'background-color 0.3s ease',
  },
  returnButtonHover: {
    backgroundColor: '#0056b3',
  },
};

export default Classroom;
